import Link from 'next/link'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const RenderMarkdown = ({ markdown }: { markdown: string }) => {
  return (
    <div className="prose prose-invert max-w-none">
      <ReactMarkdown
        components={{
          h1: ({ children }) => (
            <h1 className="mb-2 text-center">{children}</h1>
          ),
          h2: ({ children }) => (
            <h2 className="mb-2 text-center">{children}</h2>
          ),
          h3: ({ children }) => <h3 className="mb-2">{children}</h3>,
          p: ({ children }) => <p className="mb-2 text-center">{children}</p>,
          ul: ({ children }) => (
            <ul className="mb-4 list-disc pl-6 text-th-fgd-2">{children}</ul>
          ),
          li: ({ children }) => (
            <li className="mb-2 text-base text-th-fgd-2">{children}</li>
          ),
          a: ({ href, children }) => (
            <Link
              href={href || '#'}
              className="text-th-active transition-colors hover:text-th-fgd-2"
            >
              {children}
            </Link>
          ),
        }}
        remarkPlugins={[remarkGfm]}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  )
}

export default RenderMarkdown
